import React, { useEffect, useState } from "react";
import Product from "../CollectionProductScreen/Product";
import { Box, CircularProgress, Grid } from "@mui/material";
import SortContext from "context/SortContext";
import { useFilter } from "context/FilterContext";
import { useGlobalContext } from "context/GlobalContext";
import RemoveProduct from "components/ui/RemoveModal/RemoveModal";
import Home from "pages/Home";
import { ReactComponent as Background } from "assets/icons/bg.svg";

import { useNavigate, useLocation, useParams } from "react-router-dom";
import { useQuery, useQueryClient } from "@tanstack/react-query";
import config from "configs/config";
import { useInView } from "react-intersection-observer";
import { useInfiniteQuery } from "@tanstack/react-query";
import { transformData, transformDataForTrayModal } from "utils/transformdata";
import ProductSkeleton from "components/ui/Skeleton/ProductSkeleton";
import apiClient from "lib/api-client";
import GoToTop from "components/ui/GoToTop";
import { usePermissions } from "context/PermissionsContext";
import { findSpecificPage, findSpecificSubPage, hasAccessSubPage } from "utils/checkUserRigths";
import { decodeStr, encodeStr, formatString } from "utils/encodeDecodeStr";
import { useCollectionDesigns } from "features/collection/hooks/useGetCollectionProducts";
import InfiniteScroll from "react-infinite-scroll-component";
import useGetAICollectionDesigns, { useGetAIBinnysSelectDesigns, useGetAINewDesigns } from "features/collection/hooks/useGetAICollectionDesigns";
import { toDayRangeISO } from "utils/dateRangeHelper";
import { getIcon } from "utils/iconsConfig";
import { useGetDuplicateStocks } from "features/collection/hooks/useGetCollectionCategory";
import StockSetProduct from "features/Stock/StockSetProduct/components/StockSetProduct";
import BinnysSelectTable from "../Modal/Binnys_select_table/BinnysSelectTableModal";
import { usePermissionFlags } from "utils/visionRights";
import DataNotFound from "components/ui/datanotfound/DataNotFound";

function AiCollectionProduct() {
  const queryClient = useQueryClient(); // Initialize query client
  const { setSortOptions, setSelectedSortValue, search, setSearch, selectedSortValue, sortOptions, setIsEdit } = React.useContext(SortContext);
  const permission = usePermissions();
  const { setRemoveIcon, setTrashModalOpen, trashModalOpen, setFilterChangeCount, setDisplayCount, appliedStartDate, appliedEndDate } = useGlobalContext();
  const { collectionName, subcategoryId } = useParams();
  const { stockLocations } = usePermissionFlags();

  const [checkedItems, setcheckedItems] = useState({});

  const [collectionId, setCollectionId] = useState("");
  const [collectionProductData, setCollectionProductData] = useState([]);
  const [selectDesignData, setSelectDesignData] = useState([]);
  const [newDesignData, setNewDesignsData] = useState([]);
  const [stockProductData, setStockProductData] = useState([]);

  const { ref, inView } = useInView();
  const navigate = useNavigate();
  const location = useLocation(); // Capture the current location
  const [previousPath, setPreviousPath] = useState(null); // Store previous path
  const rangeStock = location?.state?.rangeStock;

  const selectedOption = sortOptions.find((option) => option.id == selectedSortValue);
  const selectedSortBY = selectedOption?.sortBy;
  const selectedSortOrder = selectedOption?.order;

  const { filterValues, setFilter, setFilterValues, setBackendFilterValues, setFilterCount, setAppliedFilterValues } = useFilter();
  const labourValues = filterValues && filterValues?.Labour?.map((item) => item.split(" - ")[0]).filter(Boolean);
  const classType = filterValues && filterValues?.Class;

  // Numeric range filters
  const diamondPieces = filterValues && filterValues["Diamond Pieces"]; // Access numeric ranges directly
  const diamondWeight = filterValues && filterValues["Diamond Weight"];
  const ratioRange = filterValues && filterValues["Ratio"];
  const goldGrossWeight = filterValues && filterValues["Gold Gross-Weight"];
  const goldNetWeight = filterValues && filterValues["Gold Net-Weight"];
  // Boolean filters or "Yes/No" type filters
  const designInCollection = filterValues && filterValues["Design In Collection"];
  const designInSets = filterValues && filterValues["Design In Sets"];
  const bestSeller = filterValues && filterValues["Best Seller Design"];
  const highestSeller = filterValues && filterValues["Highest Seller"];
  const stockStatus = filterValues && filterValues["Product Page Stock Status"];
  const isHidden = filterValues && filterValues["Show Hidden Designs"]; 

  const Location = filterValues?.Location?.map((location) => (location === "IDL" ? "Idel Inventory" : location)) || [];
  const hasAccessToSeeSales = hasAccessSubPage(findSpecificSubPage(findSpecificPage("Settings", permission), "Sales"), "view");

  let preState = location.state;
  const isStockDesign = location?.state?.isStockDesign;
  const isSelectDesign = location?.state?.isSelectDesign && collectionName === "Binny's Select Designs";
  const isNewDesigns = location?.state?.newDesigns && collectionName === "New Designs";
  // Set the previous path on component mount
  useEffect(() => {
    if (location.pathname && location.pathname !== "/") {
      const segments = location.pathname.split("/");
      const parentPath = segments.slice(0, -1).join("/");
      setPreviousPath(parentPath || "/");
    }
    //for taking user to previous scrolled position
    if (location.state?.scrollPosition !== undefined) {
      window.scrollTo(0, location.state.scrollPosition);
    }
  }, [location]);

  const noRatioCollections = [
    "Duplicate Stocks",
    "Restricted Stock"
  ];
  
  // detect: "1 to 2 Years Old Stock", "2 to 3 Years Old Stock", etc.
  const isYearOldStock = /Years Old Stock$/.test(collectionName);

  useEffect(() => {
    setFilter(true);

    //---------------- Setting Sort Options --------------------\\
    if (noRatioCollections.includes(collectionName) || isYearOldStock) {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Highest Duplicate Articles", sortBy: "Highest Articles", order: "desc" },
      ]);
    } else if (collectionName.endsWith("Stock")) {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Highest Duplicate Articles", sortBy: "Highest Articles", order: "desc" },
        { id: 10, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
        { id: 11, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
      ])
    } else if (isSelectDesign) {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc" },
        { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc" },
        { id: 11, name: "Most Quoted Design", sortBy: "MostOrder", order: "desc" },
        { id: 12, name: "Least Quoted Design", sortBy: "MostOrder", order: "asc" },
        { id: 13, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
        { id: 14, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
      ]);
    } else {
      setSortOptions([
        { id: 1, name: "Design No. (Low to High)", sortBy: "Design No", order: "asc" },
        { id: 2, name: "Design No. (High to Low)", sortBy: "Design No", order: "desc" },
        { id: 3, name: "Design Date (Oldest to Newest)", sortBy: "Design Date", order: "asc" },
        { id: 4, name: "Design Date (Newest to Oldest)", sortBy: "Design Date", order: "desc" },
        { id: 5, name: "Gold Net Weight (Low to High)", sortBy: "Gold Net Weight", order: "asc" },
        { id: 6, name: "Gold Net Weight (High to Low)", sortBy: "Gold Net Weight", order: "desc" },
        { id: 7, name: "Diamond Weight (Low to High)", sortBy: "Diamond Weight", order: "asc" },
        { id: 8, name: "Diamond Weight (High to Low)", sortBy: "Diamond Weight", order: "desc" },
        { id: 9, name: "Sales (Low to High)", sortBy: "Sales", order: "asc" },
        { id: 10, name: "Sales (High to Low)", sortBy: "Sales", order: "desc" },
        { id: 11, name: "Ratio (Low to High)", sortBy: "Ratio", order: "asc", access: true },
        { id: 12, name: "Ratio (High to Low)", sortBy: "Ratio", order: "desc", access: true },
      ]);
    }
    //---------------- Filter Slider API --------------------\\

    const fetchFilterData = async () => {
      try {
        if (location?.state?.isStockDesign && (collectionName.endsWith("Stocks") || (collectionName.endsWith("Stock") && !collectionName.includes("Out")))) {
          const filterData = {
            Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
            // Location: stockLocations,
            Location: ["Headquarters Stock", "BBM Stock", "BBM Customer Stock", "BBS Stock", "BBS Customer Stock", "IDL"],
            "Stock Status": ["All"],
            "Show Hidden Designs":false
          };
          setBackendFilterValues(filterData);
          setFilterValues(filterData);
          const filterChangeCount = JSON.parse(sessionStorage.getItem("filterChangeCount"));
          if (filterChangeCount === 0) {
            setFilterValues(filterData);
          } else {
            setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
          }
        } else {
          const response = await apiClient.post(`${config.baseUrl}/api/v1/collection/getAICollectionDesignSlidersData`, {
            days: location?.state?.days,
            newDesign: location?.state?.isNewAiDesign,
            cadDesign: location?.state?.isCadDesign,
            selectDesign: location?.state?.isSelectDesign,
            categoryName: subcategoryId.split("-")[0],
            isOutOfStock: location?.state?.isOutOfStock || "",
            rangeOutOfStock: location?.state?.rangeOutOfStock || "",
            UnderRatio: location?.state?.UnderRatio || "",
            OverRatio: location?.state?.OverRatio || "",
            newDesigns: location?.state?.newDesigns || "",
            isHidden:!isHidden
          });

          if (response.data && response.data.data) {
            const { diamondPieces, diamondWeight, grossWeight, netWeight, ratio } = response.data.data;
            const filterData = {
              "Ratio": ratio || [],
              Labour: ["R", "X", "X2", "X5", "X8", "XX"],
              Class: ["Gold", "Silver", "Bronze", "Under Ratio"],
              "Design In Collection": ["All"],
              "Design In Sets": ["All"],
              "Diamond Pieces": diamondPieces || [],
              "Diamond Weight": diamondWeight || [],
              "Gold Gross-Weight": grossWeight || [],
              "Gold Net-Weight": netWeight || [],
              "Highest Seller": [],
              "Best Seller Design": ["All"],
              ...(!location?.state?.isOutOfStock &&
                !isSelectDesign && {
                "Product Page Stock Status": ["All"],
                "Show Hidden Designs":false
              }),
              // only getSpecificAICollectionDesigns supports it
              ...(!isSelectDesign && !isNewDesigns && { "Design Create Date": [] }),
            };
            let backendOptions = { ...filterData };
              delete backendOptions["Design In Collection"];
              delete backendOptions["Design In Sets"];
              delete backendOptions["Product Page Stock Status"];
            setBackendFilterValues(backendOptions);
            setFilterValues(filterData);
            if (sessionStorage.getItem("filterChangeCount") == 0) {
              setFilterValues(filterData);
            } else {
              setFilterValues(JSON.parse(sessionStorage.getItem("appliedFilterValues")));
            }
          }
        }
      } catch (error) {
        console.error("Error fetching filter data:", error);
      }
    };

    fetchFilterData();

    return () => {
      setFilter(false);
      setSearch("");
      setSortOptions([]);
      setSelectedSortValue(null);
      setFilterValues({
        Labour: [],
        Class: [],
        "Diamond Pieces": [],
        "Diamond Weight": [],
        "Gold Gross-Weight": [],
        "Gold Net-Weight": [],
        "Design In Collection": [],
        "Design In Sets": [],
        "Highest Seller": [],
        "Best Seller Design": [],
        "Product Page Stock Status": [],
        "Show Hidden Designs":false,
        Location: [],
      });

      setCollectionProductData([]);
      setSelectDesignData([]);
      setNewDesignsData([]);
      setFilterCount(0);
      setAppliedFilterValues({});
      sessionStorage.setItem("filterChangeCount", 0);
    };
  }, [location]);

  //----------------- API Integration  ----------------\\
  let collectionNameIs = collectionName;
  let categoryNameIs = subcategoryId.split("-")[0];

  let payloadForAiApi = {
    collectionName: collectionNameIs,
    categoryName: categoryNameIs,
    days: location?.state?.days,
    newDesign: location?.state?.isNewAiDesign,
    cadDesign: location?.state?.isCadDesign,
    search: search,
    limit: 20,
    pageNumber: 1,
    sortBy: selectedSortBY,
    order: selectedSortOrder,
    labourFilter: labourValues?.length > 0 ? labourValues : "",
    classFilter: classType?.length > 0 ? classType : "",
    diamondPieces: diamondPieces?.length > 0 ? diamondPieces : "",
    diamondWeight: diamondWeight?.length > 0 ? diamondWeight : "",
    ratioRange: ratioRange?.length > 0 ? ratioRange : "",
    goldGrossWeight: goldGrossWeight?.length > 0 ? goldGrossWeight : "",
    goldNetWeight: goldNetWeight?.length > 0 ? goldNetWeight : "",
    designInCollection: designInCollection?.length > 0 ? designInCollection : "",
    designInSets: designInSets?.length > 0 ? designInSets : "",
    bestSeller: bestSeller && bestSeller[0] === "No" ? "NO" : bestSeller && bestSeller[0] === "Yes" ? "YES" : "",
    highestSeller: highestSeller && highestSeller?.length > 0 ? highestSeller : "",
    stockStatus: stockStatus && stockStatus[0],
    isOutOfStock: location?.state?.isOutOfStock || "",
    rangeOutOfStock: location?.state?.rangeOutOfStock || "",
    UnderRatio: location?.state?.UnderRatio || "",
    OverRatio: location?.state?.OverRatio || "",
    newDesigns: location?.state?.newDesigns || "",
    designCreateDate: toDayRangeISO(filterValues?.["Design Create Date"]),
    isHidden : !isHidden,
  };

  const { data, fetchNextPage, hasNextPage, isFetchingNextPage, isLoading, isError, error, refetch } = useGetAICollectionDesigns({
    ...payloadForAiApi,
    enabled: !isStockDesign && !isSelectDesign && !isNewDesigns,
  });
  const stockStatusForDublicate = filterValues["Stock Status"]?.[0] === "On Memo" ? "Memo" : filterValues["Stock Status"]?.[0] || "";
  const {
    data: duplicateStocksData,
    isLoading: isDupLoading,
    fetchNextPage: fetchNextDuplicatePage,
    hasNextPage: hasNextDuplicatePage,
    isFetchingNextPage: isFetchingNextDuplicatePage,
  } = useGetDuplicateStocks({
    collectionName,
    category: categoryNameIs,
    Class: classType?.length > 0 ? classType : "",
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    searchTerm: search,
    limit: 12,
    enabled: isStockDesign,
    restricted: collectionName === "Restricted Stock",
    rangeStock: rangeStock ? rangeStock : null,
    location: Location,
    stockStatus: stockStatusForDublicate,
    isHidden:!isHidden,
  });

  // ---------------------------------------------------------------- Binnys Select Design ------------------------------------------------------------------- \\

  const subCategoryName = location?.state?.name[2];

  let payloadForAiBinnysSelectApi = {
    collectionName: collectionNameIs,
    category: categoryNameIs,
    subcategory: subCategoryName,
    searchTerm: search,
    limit: 20,
    // page: 1,
    sortBy: selectedSortBY,
    sortOrder: selectedSortOrder,
    labourFilter: labourValues?.length > 0 ? labourValues : "",
    classFilter: classType?.length > 0 ? classType : "",
    diamondPieces: diamondPieces?.length > 0 ? diamondPieces : "",
    diamondWeight: diamondWeight?.length > 0 ? diamondWeight : "",
    ratioRange: ratioRange?.length > 0 ? ratioRange : "",
    goldGrossWeight: goldGrossWeight?.length > 0 ? goldGrossWeight : "",
    goldNetWeight: goldNetWeight?.length > 0 ? goldNetWeight : "",
    designInCollection: designInCollection?.length > 0 ? designInCollection : "",
    designInSets: designInSets?.length > 0 ? designInSets : "",
    bestSeller: bestSeller && bestSeller[0] === "No" ? "NO" : bestSeller && bestSeller[0] === "Yes" ? "YES" : "",
    highestSeller: highestSeller && highestSeller?.length > 0 ? highestSeller : "",
    stockStatus: stockStatus && stockStatus[0],
    ...(location?.state?.isSelectDesign && collectionName === "Binny's Select Designs" || location?.state?.newDesigns && collectionName === "New Designs"
      ? {
        startDate: appliedStartDate || "",
        endDate: appliedEndDate || "",
      }
      : {}),
      isHidden:!isHidden,
  };

  const {
    data: binnysSelectDesignData,
    fetchNextPage: fetchNextBinnysSelectPage,
    hasNextPage: hasNextBinnysSelectPage,
    isFetchingNextPage: isFetchingNextBinnysSelectPage,
    isLoading: isBinnysSelectLoading,
  } = useGetAIBinnysSelectDesigns({
    ...payloadForAiBinnysSelectApi,
    enabled: !!isSelectDesign,
  });

  const {
    data: binnysNewDesignsData,
    fetchNextPage: fetchNextNewDesignsPage,
    hasNextPage: hasNextNewDesignsPage,
    isFetchingNextPage: isFetchingNextNewDesignsPage,
    isLoading: isNewDesignsLoading,
  } = useGetAINewDesigns({
    ...payloadForAiBinnysSelectApi,
    enabled: !!isNewDesigns,
  });

  useEffect(() => {
    if (data && !isStockDesign) {
      const allProducts = data.pages.flatMap((page) => page.designs);
      const uniqueProducts = Array.from(new Map(allProducts.map((product) => [product.styleNumber, product])).values());
      setCollectionProductData(uniqueProducts);
    }
  }, [data, isStockDesign]);

  useEffect(() => {
    if (binnysSelectDesignData && isSelectDesign || binnysNewDesignsData && isNewDesigns) {
      let allProducts = [];
      if (binnysSelectDesignData) {
        allProducts = binnysSelectDesignData.pages.flatMap((page) => page.designs);
        setSelectDesignData(allProducts);
      }
      else {
        allProducts = binnysNewDesignsData?.pages.flatMap((page) => page.designs);
        setNewDesignsData(allProducts);
      }
      // const uniqueProducts = Array.from(new Map(allProducts.map((product) => [product.styleNumber, product])).values());
    }
  }, [binnysSelectDesignData, isSelectDesign, binnysNewDesignsData, isNewDesigns]);

  useEffect(() => {
    setFilterChangeCount(data?.pages[0]?.totalCount || duplicateStocksData?.pages[0].totalCount || binnysSelectDesignData?.pages[0].totalCount || binnysNewDesignsData?.pages[0]?.totalCount);
    const combinedData = duplicateStocksData?.pages?.flatMap((page) => page?.duplicateStocks);
    setStockProductData(combinedData);
    setDisplayCount(true);
    return () => {
      setFilterChangeCount(0);
      setDisplayCount(false);
    };
  }, [data, duplicateStocksData, binnysSelectDesignData, binnysNewDesignsData]);

  //----------- When user Copy Paste URL -------------------\\
  useEffect(() => {
    const decodedCollectionName = decodeURIComponent(collectionName);
    let collectionCatgeoryName = decodeURIComponent(subcategoryId).split("-")[0];
    // Top 30 Sold - 30 Days
    //All
    const aiPages = ["Top 30 Sold - 30 Days", "Top 60 Sold - 60 Days", "Top 90 Sold - 90 Days", "New 30 Sold - 30 Days", "New 60 Sold - 60 Days", "New 90 Sold - 90 Days", "Only Cad Designs"];

    let isAiPage = aiPages.includes(decodedCollectionName);
    if (!location.state?.name) {
      if (isAiPage) {
        let isCadDesign = decodedCollectionName === "Only Cad Designs";

        let days = isCadDesign ? "" : Number(decodedCollectionName.split("-")[1]?.split(" ")[1]) || "";

        let isNewAiDesign = isCadDesign ? "" : !decodedCollectionName.startsWith("Top");

        navigate(location.pathname, { state: { name: [decodedCollectionName, `${collectionCatgeoryName}`], days, isNewAiDesign, isCadDesign, aiIcon: true }, replace: true });
      }
    }
  }, []);

  //------------ When their is change in any of this value api call will happen -----------\\
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [selectedSortValue, filterValues, search]);

  //------------------------------------------------------\\

  const handleCheckboxChange = (itemId) => (event) => {
    setcheckedItems((prevCheckedItems) => {
      const newCheckedItems = { ...prevCheckedItems };

      if (event.target.checked) {
        newCheckedItems[itemId] = true;
      } else {
        delete newCheckedItems[itemId];
      }
      return newCheckedItems;
    });
  };

  const btnInfo = [
    {
      btnName: "Remove",
      bgColor: "#E77B7B",
      click: async () => {
        const findRemoveProductIds = Object.keys(checkedItems);
        const currentScrollPosition = window.scrollY;
        const payload = {
          collectionId: JSON.parse(sessionStorage.getItem("collectionIdOfProducts")),
          styleRefIds: findRemoveProductIds,
        };

        const removeDesignResponse = await apiClient.post(`${config.baseUrl}/api/v1/collection/removeDesign`, payload);

        if (removeDesignResponse.status === 200) {
          // queryClient.removeQueries("collectiondesigns", { exact: true });

          let currentPage = location.state.name[location.state.name.length - 1];

          if (removeDesignResponse.data.updatedCollection.numberOfStyles === 0) {
            navigate("/Collection");
          } else {
            let getCategories = removeDesignResponse.data.updatedCollection.categories;
            let totalCount = getCategories.reduce((acc, cat) => {
              return acc + cat.count;
            }, 0);
            let currentPageName = currentPage.split("-");
            currentPageName = currentPageName[0].split(" ");
            let findCurrentPageDesignCount;
            if (currentPageName[0] === "All") {
              findCurrentPageDesignCount = {
                categoryName: "All",
                count: totalCount,
              };
            } else {
              findCurrentPageDesignCount = getCategories.find((cat) => {
                if (cat.categoryName === currentPageName[0]) {
                  return cat.count;
                }
              });
            }

            if (!(findCurrentPageDesignCount?.count > 0)) {
              const currentPreState = { ...preState, name: [...preState.name] };

              navigate(previousPath || "/Collection", { state: currentPreState });
            } else {
              const updatedState = {
                ...location.state,
                name: [`${location.state.name[0]}`, `${currentPage.split(" - ")[0]}`],
                // name: [`${location.state.name[0]}`, `${currentPage.split(" - ")[0]} - ${findCurrentPageDesignCount?.count || 0}`],
                scrollPosition: currentScrollPosition,
              };

              // Navigate to the same path with the updated state for showing updated count
              navigate(location.pathname, { state: updatedState });
            }
          }

          setTrashModalOpen(false);
          setcheckedItems({});
          await refetch();
        } else {
          alert(removeDesignResponse.message);
        }
      },
    },
    {
      btnName: "Keep",
      bgColor: "#50C878",
      click: () => {
        setTrashModalOpen(false);
        setcheckedItems({});
      },
    },
  ];

  useEffect(() => {
    if (Object.keys(checkedItems).length > 0) {
      setRemoveIcon(true);
    } else {
      setRemoveIcon(false);
    }
    return () => setRemoveIcon(false);
  }, [checkedItems]);

  useEffect(() => {
    return () => {
      setFilterValues({});
      setFilterCount(0);
      setAppliedFilterValues({});
      sessionStorage.setItem("filterChangeCount", 0);
    };
  }, []);

  const dataLength = isStockDesign
    ? duplicateStocksData?.pages?.flatMap((page) => page.duplicateStocks)?.length || 0
    : isSelectDesign
      ? selectDesignData?.length || 0
      : isNewDesigns
        ? newDesignData?.length || 0
        : collectionProductData?.length || 0;

  if (isError) return <div>Error: {error.message}</div>;

  if (isLoading || isDupLoading || isBinnysSelectLoading || isNewDesignsLoading) return <ProductSkeleton count={20} />;

  const hasNoResults = search && dataLength === 0;
  if (hasNoResults) return <DataNotFound message={`No results found for "${search}"`} />;

  if (dataLength === 0) return <ProductSkeleton count={20} />;

  return (
    <>
      <InfiniteScroll
        dataLength={isStockDesign ? duplicateStocksData?.pages?.flatMap((page) => page.duplicateStocks)?.length || 0 : isSelectDesign ? selectDesignData?.length : isNewDesigns ? newDesignData?.length : collectionProductData?.length || 0}
        next={isStockDesign ? fetchNextDuplicatePage : isSelectDesign ? fetchNextBinnysSelectPage : isNewDesigns ? fetchNextNewDesignsPage : fetchNextPage}
        hasMore={isStockDesign ? hasNextDuplicatePage : isSelectDesign ? hasNextBinnysSelectPage : isNewDesigns ? hasNextNewDesignsPage : hasNextPage}
        loader={(isStockDesign ? isFetchingNextDuplicatePage : isSelectDesign ? isFetchingNextBinnysSelectPage : isNewDesigns ? isFetchingNextNewDesignsPage : isFetchingNextPage) && <ProductSkeleton count={21} />}
        scrollThreshold={0.8}
        endMessage={<p style={{ textAlign: "center" }}>You have seen it all!</p>}
      >
        <Grid
          container
          direction="row"
          justifyContent="flex-start"
          sx={{
            flex: "1 1 1",
            display: "flex",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "30px",
            rowGap: "32px",
          }}
          className="Grid-padding"
          rowGap={"16px"}
        >
          {isStockDesign
            ? duplicateStocksData?.pages?.map((page) => page?.duplicateStocks?.map((design) => <StockSetProduct product={design} key={design._id} allData={stockProductData} />))
            : (!isSelectDesign ? !isNewDesigns ? collectionProductData : newDesignData : selectDesignData)?.map((product, ind) => (
              <Product
                product={transformDataForTrayModal(product)}
                index={ind}
                key={product?._id}
                handleCheckboxChange={handleCheckboxChange}
                checkedItems={checkedItems}
                isAiDesign={true}
                allData={!isSelectDesign ? !isNewDesigns ? collectionProductData : newDesignData : selectDesignData}
              />
            ))}

          <RemoveProduct open={trashModalOpen} setOpen={setTrashModalOpen} btnInfo={btnInfo} heading="Do you want to remove the Design?" />
        </Grid>
      </InfiniteScroll>

      <GoToTop />

    </>
  );
}

export default AiCollectionProduct;
